import React from "react";
import SuspenseWrapper from "../../component/SuspenseWrapper";
const BasicDetails = React.lazy(() => import("@/pages/profile/BasicDetails"));
const Contact = React.lazy(() => import("@/pages/profile/Contact"));
const WorkingInformation = React.lazy(() =>
  import("@/pages/profile/WorkingInformation")
);
const HrInformation = React.lazy(() => import("@/pages/profile/HrInformation"));
const AccountInformation = React.lazy(() =>
  import("@/pages/profile/AccountInformation")
);
const EducationalInformation = React.lazy(() =>
  import("@/pages/profile/EducationInformation")
);
const ExperienceInformation = React.lazy(() =>
  import("@/pages/profile/ExperienceInformation")
);
const OtherDocument = React.lazy(() => import("@/pages/profile/OtherDocument"));
const FamilyDetails = React.lazy(() => import("@/pages/profile/FamilyDetails"));
const FollowUp = React.lazy(() => import("@/pages/profile/FollowUp"));
const ProbationInformation = React.lazy(() =>
  import("@/pages/profile/ProbationInformation")
);

const Settings = [
  {
    path: "basicDetails",
    element: (
      <SuspenseWrapper>
        <BasicDetails />
      </SuspenseWrapper>
    ),
  },
  {
    path: "contact",
    element: (
      <SuspenseWrapper>
        <Contact />
      </SuspenseWrapper>
    ),
  },
  {
    path: "workingInformation",
    element: (
      <SuspenseWrapper>
        <WorkingInformation />
      </SuspenseWrapper>
    ),
  },

  {
    path: "hrInformation",
    element: (
      <SuspenseWrapper>
        <HrInformation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "accountInformation",
    element: (
      <SuspenseWrapper>
        <AccountInformation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "education",
    element: (
      <SuspenseWrapper>
        <EducationalInformation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "experience",
    element: (
      <SuspenseWrapper>
        <ExperienceInformation />
      </SuspenseWrapper>
    ),
  },
  {
    path: "family",
    element: (
      <SuspenseWrapper>
        <FamilyDetails />
      </SuspenseWrapper>
    ),
  },
  {
    path: "otherDocuments",
    element: (
      <SuspenseWrapper>
        <OtherDocument />
      </SuspenseWrapper>
    ),
  },
  {
    path: "followUp",
    element: (
      <SuspenseWrapper>
        <FollowUp />
      </SuspenseWrapper>
    ),
  },
  {
    path: "probationInformation",
    element: (
      <SuspenseWrapper>
        <ProbationInformation />
      </SuspenseWrapper>
    ),
  },
];

export default Settings;
